import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { GetValuationByIdDTO } from '../../services/patent-repository';
import { GetPatentValuation } from '@/infrastructure/api-functions/core-search-api/get-patent-valuation-api';

@injectable()
export class GetValuationByIdDTOImpl implements GetValuationByIdDTO {
    constructor(
        @inject(GetPatentValuation)
        private _getPatentValuationApi: GetPatentValuation,
    ) {
    }

    public async getValuationById(patentId: string) {
        const result = await this._getPatentValuationApi.getPatentValuation(patentId);

        return {
            indepClaimCount: result.indep_claim_count,
            invalidOpposition: result.invalid_opposition,
            simpleFamilyCount: result.simple_family_count,
            simpleFamilyCountry: result.simple_family_country,
            citedCount: result.cited_count,
            inventorCount: result.inventor_count,
            growthRate: result.growth_rate,
            licenseOrTransfer: result.license_or_transfer,
            familyActiveArea: result.family_active_area,
            maintenancePeriod: result.maintenance_period,
        };
    }
}
